import React from 'react';

/**
 * Skeleton placeholder for a loading discover rail.
 * 6 cards in a horizontal strip with shimmer animation.
 * Drops into the same layout slot as <Rail/> so the page doesn't reflow
 * once the real data arrives.
 */
const RailSkeleton = ({ heroes = 0 }) => (
  <div className="space-y-8 sm:space-y-10 animate-pulse">
    {/* Hero placeholder */}
    {heroes > 0 && (
      <div className="mx-3 sm:mx-6 rounded-2xl aspect-[16/9] sm:aspect-[21/8] bg-gradient-to-br from-slate-800 to-slate-900 ring-1 ring-slate-700/40" />
    )}

    {[0, 1, 2].map((row) => (
      <div key={row} className="space-y-3">
        <div className="px-4 sm:px-6 flex justify-between items-center">
          <div className="h-6 w-40 bg-slate-800 rounded" />
          <div className="h-3 w-12 bg-slate-800 rounded" />
        </div>
        <div className="flex gap-3 sm:gap-4 overflow-hidden px-4 sm:px-6">
          {[0, 1, 2, 3, 4, 5].map((c) => (
            <div
              key={c}
              className="flex-shrink-0 w-[150px] sm:w-[180px] lg:w-[200px]"
            >
              <div className="aspect-[3/4] rounded-xl bg-gradient-to-br from-slate-800 to-slate-900 ring-1 ring-slate-700/40" />
              <div className="mt-2 h-3 w-3/4 bg-slate-800 rounded" />
              <div className="mt-1 h-2 w-1/2 bg-slate-800 rounded" />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default RailSkeleton;
